import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useCurrency } from '../context/CurrencyContext';
import { formatPrice } from '../utils/currencyUtils';
import './ThankYou.css';

function ThankYou() {
  const location = useLocation();
  const { currency } = useCurrency();
  const { orderNumber, orderId, paymentMethod, transactionId } = location.state || {};

  return (
    <div className="thank-you-page">
      <div className="thank-you-hero">
        <div className="thank-you-hero-content">
          <h1>Order Confirmed!</h1>
          <p>Thank you for your purchase</p>
        </div>
      </div>

      <div className="thank-you-container">
        <div className="thank-you-content">
          <div className="success-icon">✅</div>
          
          <h1>Thank You for Your Order!</h1>
          <p>Your order has been successfully placed and is being processed.</p>
          
          <div className="receipt-section">
            <h3>Order Receipt</h3>
            <div className="receipt-details">
              {orderNumber && (
                <div className="receipt-row">
                  <span>Order Number:</span>
                  <span className="receipt-value">{orderNumber}</span>
                </div>
              )}
              {orderId && (
                <div className="receipt-row">
                  <span>Order ID:</span>
                  <span className="receipt-value">{orderId}</span>
                </div>
              )}
              <div className="receipt-row">
                <span>Order Date:</span>
                <span className="receipt-value">{new Date().toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}</span>
              </div>
              {paymentMethod && (
                <div className="receipt-row">
                  <span>Payment Method:</span>
                  <span className="receipt-value">{paymentMethod}</span>
                </div>
              )}
              {transactionId && (
                <div className="receipt-row">
                  <span>Transaction ID:</span>
                  <span className="receipt-value receipt-transaction">{transactionId}</span>
                </div>
              )}
              <div className="receipt-row receipt-total">
                <span>Total Paid:</span>
                <span className="receipt-value receipt-amount">{formatPrice(location.state?.total || 0, currency)}</span>
              </div>
            </div>
          </div>

          <div className="action-buttons">
            <Link to="/" className="back-home-btn">
              🏠 Back to Home
            </Link>
            <Link to="/products" className="continue-shopping-btn">
              Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYou; 